const initialSourceOfEvidence = {
  sourceOfEvidencePermissions: {},
  sourceOfEvidenceLists: [],
  sourceOfEvidenceStatus: [],
  changedSourceOfEvidenceStatus: [],
  loadingSourceOfEvidence: false,
  errorsSourceOfEvidence: {},
};

const sourceOfEvidenceReducer = (sourceOfEvidence = initialSourceOfEvidence, action) => {
  switch (action.type) {
    case "GET_SOURCEOFEVIDENCELIST_PENDING":
    case "ADD_SOURCE_OF_EVIDENCE_PENDING":
    case "UPDATE_SOURCE_OF_EVIDENCE_PENDING":
    case "UPDATE_SOURCE_OF_EVIDENCE_STATUS_PENDING":
    case "DELETE_SOURCE_OF_EVIDENCE_PENDING":
    case "GET_SOURCEOFEVIDENCELISTBYID_PENDING":
      return { ...sourceOfEvidence, loadingSourceOfEvidence: true };

    case "GET_SOURCEOFEVIDENCELIST_FULFILLED":
      return {
        ...sourceOfEvidence,
        loadingSourceOfEvidence: false,
        sourceOfEvidenceLists: action.payload,
        sourceOfEvidenceCount: action.count,
        sourceOfEvidencePermissions: action.permissions,
      };

    case "ADD_SOURCE_OF_EVIDENCE_FULFILLED":
    case "UPDATE_SOURCE_OF_EVIDENCE_FULFILLED":
    case "UPDATE_SOURCE_OF_EVIDENCE_STATUS_FULFILLED":
    case "DELETE_SOURCE_OF_EVIDENCE_FULFILLED":
      return {
        ...sourceOfEvidence,
        loadingSourceOfEvidence: false,
        changedSourceOfEvidenceStatus: action.payload,
      };

    case "GET_SOURCEOFEVIDENCELISTBYID_FULFILLED":
      return {
        ...sourceOfEvidence,
        loadingSourceOfEvidence: false,
        sourceOfEvidenceLists: action.payload,
      };

    case "RESET_DELETE_SOURCE_OF_EVIDENCE_STATUS":
      return {
        ...sourceOfEvidence,
        loadingSourceOfEvidence: false,
        sourceOfEvidenceStatus: {},
        changedSourceOfEvidenceStatus: [],
        errorsSourceOfEvidence: {},
      };

    case "GET_SOURCEOFEVIDENCELIST_REJECTED":
    case "ADD_SOURCE_OF_EVIDENCE_REJECTED":
    case "UPDATE_SOURCE_OF_EVIDENCE_REJECTED":
    case "UPDATE_SOURCE_OF_EVIDENCE_STATUS_REJECTED":
    case "DELETE_SOURCE_OF_EVIDENCE_REJECTED":
    case "GET_SOURCEOFEVIDENCELISTBYID_REJECTED":
      return {
        ...sourceOfEvidence,
        loadingSourceOfEvidence: false,
        errorsSourceOfEvidence: action.payload,
      };

    default:
      return sourceOfEvidence;
  }
};

export default sourceOfEvidenceReducer;
